module.exports = __webpack_public_path__ + "static/img/1060_small.72e3fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1060_small.png
// module id = CPpd
// module chunks = 1